import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "@/lib/smooth";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const lenisRef = useLenis();

  useEffect(() => {
    const lenis = lenisRef && lenisRef.current;
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, lenisRef]);

  return null;
}
